// extracted by mini-css-extract-plugin
module.exports = {"title":"ValidatorNumbers_title__3WGNd","numbers":"ValidatorNumbers_numbers__1uu8s","item":"ValidatorNumbers_item__wI5uC","value":"ValidatorNumbers_value__FEs6Q"};